import styled from '@emotion/styled';

export default styled.span({
    paddingLeft: '0.5rem',
    [':hover']: {
        fill: 'red',
        cursor: 'pointer'
    }
});
